module.exports = __webpack_public_path__ + "media/images/redesign-images/higher-ed/school3-f93fb1ac0a86a3754b60f504bb38b6b1.svg";